import React, { useState } from "react";
import Button from "components/utils/Button";
import HeaderLink from "components/utils/HeaderLink";
import { ReactComponent as Logo } from "assets/logo/lark_stretch_logo_final-wersja-white.svg";
import { Link, useLocation } from "react-router-dom";
import pages from "utils/data/pages.json";
import classNames from "classnames";
import { useScreenSize } from "utils/hooks/useScreenSize";
import ContactModal from "components/Modals/Contact.modal";
import { ButtonSize } from "utils/types/util.types";
import LanguageSwitch from "components/utils/LanguageSwitch";
import { useTranslation } from "react-i18next";

function Header() {

	const { pathname } = useLocation();

	const [ isMobileMenuOpen, toggleMobileMenuOpen ] = useState(false);

	const [ isContactModalOpen, toggleContactModalOpen ] = useState(false);

	const screenSize = useScreenSize();

	const { t } = useTranslation();

	return (
		<>
			<ContactModal
				isOpen={ isContactModalOpen }
				toggleModalOpen={ () => toggleContactModalOpen(isOpen => !isOpen) }
			/>
			<header className="header bg-gray-900 pb-4">
				<div className="container flex justify-between items-center">
					{
						pathname === "/" ?
							<div className="header__logo-wrapper cursor-pointer" onClick={ () => window.scrollTo({ top: 0, left: 0, behavior: "smooth" }) }>
								<Logo className="h-[50px] md:h-[100px] w-[125px] md:w-[200px]"/>
							</div> :
							<Link to="/" className="header__logo-wrapper">
								<Logo className="h-[50px] md:h-[100px] w-[125px] md:w-[200px]"/>
							</Link>
					}
					<nav className={ classNames("header__navigation", { "header__navigation--open": isMobileMenuOpen }) }>
						<div className={ classNames("header__backdrop", { "header__backdrop--menu-open": isMobileMenuOpen }) } onClick={ () => toggleMobileMenuOpen(isOpen => !isOpen) }></div>
						<ul className="list-none flex gap-14">
							{
								pages.map(({ name, link, id }) =>
									<HeaderLink
										key={ `${ name }-${ link }` }
										link={ link }
										onClick={ screenSize.width < 1000 ? () => toggleMobileMenuOpen(isOpen => !isOpen) : undefined }
									>
										{ t(`pages.${ id }`) }
									</HeaderLink>
								)
							}
						</ul>
						<div className="header__mobile-items items-start flex flex-col gap-[25px]">
							<Button
								size={ ButtonSize.SMALL }
								onClick={ () => toggleContactModalOpen(true) }
							>
								{ t("header.contactButtonText") }
							</Button>
							<LanguageSwitch/>
						</div>
					</nav>
					<div className="header__desktop-items flex items-center gap-7">
						<LanguageSwitch/>
						<Button onClick={ () => toggleContactModalOpen(true) }>
							{ t("header.contactButtonText") }
						</Button>

					</div>
					<div className="header__burger">
						<label htmlFor="check">
							<input
								type="checkbox"
								id="check"
								onChange={ () => undefined }
								checked={ isMobileMenuOpen }
								onClick={ e => {
									e.stopPropagation();
									toggleMobileMenuOpen(isOpen => !isOpen)
								} }
							/>
							<span></span>
							<span></span>
							<span></span>
						</label>
					</div>
				</div>
			</header>
		</>
	);
}

export default Header;